import { render, staticRenderFns } from "./UtentiImpianto.vue?vue&type=template&id=c2548220&"
import script from "./UtentiImpianto.vue?vue&type=script&lang=js&"
export * from "./UtentiImpianto.vue?vue&type=script&lang=js&"
import style0 from "./UtentiImpianto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports